import { Component, ElementRef, OnInit } from '@angular/core'
import {
  AnonymousConsentsConfig,
  AnonymousConsentsService,
  CmsComponentConnector,
  CmsLinkComponent,
  RoutingService
} from '@spartacus/core'
import { AnonymousConsentDialogComponent, LaunchDialogService } from '@spartacus/storefront'
import { Observable } from 'rxjs'
import { map, switchMap } from 'rxjs/operators'

@Component({
    selector: 'eb-anonymous-consent-dialog',
    templateUrl: './eb-anonymous-consent-dialog.component.html',
    styleUrls: ['./eb-anonymous-consent-dialog.component.scss'],
    standalone: false
})
export class EbAnonymousConsentDialogComponent extends AnonymousConsentDialogComponent implements OnInit {
  linkComponent$: Observable<CmsLinkComponent>
  matomoUrl= '<script src=\'https://myeagleburgmann.matomo.cloud/index.php?module=CoreAdminHome&action=optOutJS&divId=matomo-opt-out&language=auto&backgroundColor=FFFFFF&fontColor=000000&fontSize=12px&fontFamily=Barlow,Arial&showIntro=1\'></script>'

  constructor(
    config: AnonymousConsentsConfig,
    anonymousConsentsService: AnonymousConsentsService,
    el: ElementRef,
    launchDialogService: LaunchDialogService,
    protected routingService: RoutingService,
    protected cmsComponentConnector: CmsComponentConnector
  ) {
    super(config, anonymousConsentsService, el, launchDialogService)
    this.linkComponent$ = this.routingService
      .getRouterState()
      .pipe(
        switchMap(routerState =>
          this.cmsComponentConnector
            .getList(['dataPrivacyStatementLink'], routerState.state.context)
            .pipe(map(components => components[0]))
        )
      )
  }

  ngOnInit(): void {
    const fragment = document.createRange().createContextualFragment('<script src=\'https://myeagleburgmann.matomo.cloud/index.php?module=CoreAdminHome&action=optOutJS&divId=matomo-opt-out&language=auto&backgroundColor=FFFFFF&fontColor=000000&fontSize=12px&fontFamily=Barlow,Arial&showIntro=1\'></script>');
    document.getElementsByClassName('matomo-cx-dialog-content')[0].appendChild(fragment)
  }
}
